module.exports = "<svg viewBox=\"0 0 7.8 32.4\"><path d=\"M7.8 0H0v32.4h7.8V0z\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/line.svg
// module id = 298
// module chunks = 1